// extracted by mini-css-extract-plugin
module.exports = {"list":"EventsSpeakersList-module__list___2a0Q_","item":"EventsSpeakersList-module__item___3fHxz"};